@if (logo()) {
  <div class="logo mb-3">
    <img src="/assets/icon/profile.svg" alt="Lyceo logo" />
  </div>
}
<ng-content select="[header]" />
<lyceo-card class="card">
  <ng-content />
</lyceo-card>
<ng-content select="[footer]" />
